import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {YesNoModal} from "../elements/YesNoModal";

export class DeleteUserModal extends Component {
    constructor(props) {
        super(props);

        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete () {
        new APIClient(API_URL + `user/${this.props.userId}/delete`).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }

            this.props.removeDeletedUser(this.props.userId);
        })
    }

    render() {
        return <YesNoModal onYesAnswer={this.handleDelete}
                           title="Estas a punto de eliminar un usuario"
                           message="Al confirmar esta operación de borrarán de forma permanente todos los datos y preferencias del usuario. La operación no es reversible."
                           question="¿Estás seguro que querés eliminar al usuario?"
                           buttonClassName={""}
                           buttonText={""}
                           buttonIconName={"trash"}
        />
    }
}

